import React from 'react';
import { COMPANY } from '@ApplicationWide/routes/route-groups';
import { SparkleIcon } from '@Generic/icons';

const OrgChartPaywall = React.lazy(() => import('../../../pages/Company/OrgChartPaywall'));

export default {
  label: 'org-chart-page.title',
  group: COMPANY,
  to: '/company/org-chart-paywall',
  route: '/company/org-chart-paywall',
  area: 'orgChartPaywall', // Area is used to check if user has permission to view that Page or not, in case of no area given the page is always visible.
  orderInGroup: 30,
  component: OrgChartPaywall,
  icon: <SparkleIcon />,
  isDesktopOnly: true,
  appearsInNavBar: true,
  hasNavBar: true,
};
